/* RESPONSIBLE TEAM: team-fin-voice */
/* eslint-disable @intercom/intercom/no-bare-strings */

export type FinVoiceCsatTtsOptions = {
  text: string;
  value: string;
};

export const FIN_VOICE_CSAT_TTS_OPTIONS: FinVoiceCsatTtsOptions[] = [
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.usa-english',
    value: 'en-US',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.uk-english',
    value: 'en-GB',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.french',
    value: 'fr-FR',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.german',
    value: 'de-DE',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.spanish',
    value: 'es-ES',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.portuguese',
    value: 'pt-PT',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.br-portuguese',
    value: 'pt-BR',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.arabic',
    value: 'ar-AE',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.catalan',
    value: 'ca-ES',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.chinese-cantonese',
    value: 'yue-CN',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.chinese-mandarin',
    value: 'cmn-CN',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.danish',
    value: 'da-DK',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.dutch',
    value: 'nl-NL',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.finnish',
    value: 'fi-FI',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.hindi',
    value: 'hi-IN',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.italian',
    value: 'it-IT',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.japanese',
    value: 'ja-JP',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.korean',
    value: 'ko-KR',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.norwegian',
    value: 'nb-NO',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.polish',
    value: 'pl-PL',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.swedish',
    value: 'sv-SE',
  },
  {
    text: 'operator.workflows.visual-builder.hold-and-assign-editor.exit-tab.audio-snippet-editor.turkish',
    value: 'tr-TR',
  },
];
